import { render, staticRenderFns } from "./CrmTimelineItem.vue?vue&type=template&id=5dbd1e2a&scoped=true"
import script from "./CrmTimelineItem.vue?vue&type=script&lang=js"
export * from "./CrmTimelineItem.vue?vue&type=script&lang=js"
import style0 from "./CrmTimelineItem.vue?vue&type=style&index=0&id=5dbd1e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbd1e2a",
  null
  
)

export default component.exports